import React from 'react';
import Link from 'shared/components/Link';
import { T, useTranslate } from 'shared/helper/translate';
var RubriqSetupStepBackLink = function RubriqSetupStepBackLink(_ref) {
  var session = _ref.session,
    previousStep = _ref.previousStep;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, previousStep ? /*#__PURE__*/React.createElement(Link, {
    to: "/rubriq/abstract-writer/".concat(session, "/criteria/").concat(previousStep),
    className: "btn btn-outline-primary py-1 px-sm-5 w-mobile-50"
  }, /*#__PURE__*/React.createElement(T, {
    source: "back"
  })) : /*#__PURE__*/React.createElement("button", {
    "aria-label": t('back'),
    type: "button",
    disabled: true,
    className: "btn btn-outline-primary py-1 px-sm-5 w-mobile-50"
  }, /*#__PURE__*/React.createElement(T, {
    source: "back",
    className: "text-secondary"
  })));
};
export default RubriqSetupStepBackLink;